import appGlobalScript from '/Users/runner/work/1/s/libs/core/components/web/jobs/src/global/global.ts';
export const globalScripts = appGlobalScript;
